if (!customElements.get('byte-video-tabs')) {
  class ByteVideoTabs extends HTMLElement {
    #tabs = null;
    #mo = null;
    #mq = null;
    #boundClick = null;
    #boundMq = null;

    connectedCallback() {
      this.#tabs = this.querySelector('x-tabs.video-tabs');
      if (!this.#tabs) {
        return;
      }

      this.#boundClick = (event) => {
        if (!event.target.closest('.video-tabs__title')) {
          return;
        }

        queueMicrotask(() => this.#scrollSelectedIntoView());
      };

      this.#tabs.addEventListener('click', this.#boundClick);

      this.#mo = new MutationObserver(() => this.#scrollSelectedIntoView());
      this.#mo.observe(this.#tabs, { attributes: true, attributeFilter: ['selected-index'] });

      this.#mq = window.matchMedia('(max-width: 699px)');
      this.#boundMq = () => this.#scrollSelectedIntoView();
      if (this.#mq.addEventListener) {
        this.#mq.addEventListener('change', this.#boundMq);
      } else {
        this.#mq.addListener(this.#boundMq);
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.#scrollSelectedIntoView());
      });
    }

    disconnectedCallback() {
      if (this.#tabs && this.#boundClick) {
        this.#tabs.removeEventListener('click', this.#boundClick);
      }

      this.#mo?.disconnect();
      this.#mo = null;

      if (this.#mq && this.#boundMq) {
        if (this.#mq.removeEventListener) {
          this.#mq.removeEventListener('change', this.#boundMq);
        } else {
          this.#mq.removeListener(this.#boundMq);
        }
      }

      this.#mq = null;
      this.#tabs = null;
      this.#boundClick = null;
      this.#boundMq = null;
    }

    #scrollSelectedIntoView() {
      if (!this.#tabs || !window.matchMedia('(max-width: 699px)').matches) {
        return;
      }

      const selected = this.#tabs.querySelector('.video-tabs__title[aria-selected="true"]');
      selected?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  }

  customElements.define('byte-video-tabs', ByteVideoTabs);
}
